import { isFinanceProject, isGlobalProject } from 'config';
import { applySchema } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import {
  PlaceOfBirthFormType,
  placeOfBirthSchema,
} from 'modules/client/common/forms/placeOfBirthForm';
import {
  ReasonChangeFormType,
  reasonChangeSchema,
} from 'modules/client/common/forms/reasonChangeForm';

import { CitizenshipFormType, citizenshipsSchema } from './citizenshipForm';
import {
  PepConnectionFormType,
  getPepConnectionSchema,
} from './pepConnectionForm';
import {
  PersonalDataFormType,
  getPersonalDataSchema,
} from './personalDataForm';
import {
  LegalClientHeadPositionFormType,
  getLegalClientHeadPositionFormSchema,
} from './positionInCompanyForm';
import {
  RegistrationAddressFormType,
  registrationAddressSchema,
} from './registrationAddressForm';
import {
  ResidentialAddressFormType,
  residentialAddressWithFilesSchema,
} from './residentialAddressForm';
import {
  TaxResidencyFormType,
  getTaxResidencesSchema,
} from './taxResidencyForm';

export interface LegalClientHeadFormType
  extends LegalClientHeadPositionFormType,
    PersonalDataFormType,
    CitizenshipFormType,
    TaxResidencyFormType,
    RegistrationAddressFormType,
    ResidentialAddressFormType,
    PepConnectionFormType,
    PlaceOfBirthFormType,
    ReasonChangeFormType {}

export const getSchema = (t: TFunc): ObjectSchema<LegalClientHeadFormType> => {
  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();
  return object()
    .concat(getPersonalDataSchema(t))
    .concat(citizenshipsSchema)
    .concat(getTaxResidencesSchema())
    .concat(residentialAddressWithFilesSchema)
    .concat(applySchema(isFinance, registrationAddressSchema))
    .concat(applySchema(isGlobal, placeOfBirthSchema))
    .concat(getLegalClientHeadPositionFormSchema(t))
    .concat(getPepConnectionSchema(t, { notRequestInformation: isGlobal }))
    .concat(reasonChangeSchema);
};

export const { Field, Form, useFormContext, Submit } =
  TypedForm<LegalClientHeadFormType>();

export type FormErrors = FormErrorsBase<LegalClientHeadFormType>;
